import { Injectable, OnDestroy } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutDeliveryAddressClearedEvent, CheckoutDeliveryAddressCreatedEvent, CheckoutDeliveryAddressFacade, CheckoutDeliveryAddressSetEvent, CheckoutQueryResetEvent, CheckoutSupportedDeliveryModesQueryResetEvent } from '@spartacus/checkout/base/root';
import {
  DeleteUserAddressEvent,
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  LoadUserAddressesEvent,
  OCC_USER_ID_ANONYMOUS,
  UpdateUserAddressEvent,
  UserAddressEvent
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class CustomCheckoutDeliveryAddressEventListener implements OnDestroy {
  protected subscriptions = new Subscription();

  constructor(
    protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    protected eventService: EventService,
    protected globalMessageService: GlobalMessageService,
    protected activeCartFacade: ActiveCartFacade
  ) {
    this.onDeliveryAddressCreated();
    this.onDeliveryAddressSet();
    this.onDeliveryAddressCleared();

    this.onUserAddressChange();
  }

  protected onUserAddressChange(): void {
    this.subscriptions.add(
      this.eventService
        .get(UserAddressEvent)
        .pipe(
          filter(
            (event) =>
              event instanceof UpdateUserAddressEvent ||
              event instanceof DeleteUserAddressEvent
          ),
          switchMap(({ userId }) =>
            this.activeCartFacade
              .takeActiveCartId()
              .pipe(map((cartId) => ({ cartId, userId })))
          )
        )
        .subscribe(({ cartId, userId }) => {
          this.checkoutDeliveryAddressFacade.clearCheckoutDeliveryAddress();

          this.eventService.dispatch(
            { cartId, userId },
            CheckoutSupportedDeliveryModesQueryResetEvent
          );
        })
    );
  }

  protected onDeliveryAddressCreated(): void {
    this.subscriptions.add(
      this.eventService
        .get(CheckoutDeliveryAddressCreatedEvent)
        .subscribe(({ cartId, userId }) => {
          if (userId !== OCC_USER_ID_ANONYMOUS) {
            this.eventService.dispatch({ userId }, LoadUserAddressesEvent);
          }

          this.subscriptions.add(this.activeCartFacade.isGuestCart().pipe(take(1)).subscribe((isGuest) => {
            if (!isGuest) {
              this.globalMessageService.add(
                { key: 'addressForm.userAddressAddSuccess' },
                GlobalMessageType.MSG_TYPE_CONFIRMATION
              );
            }
          }))

          this.eventService.dispatch(
            { userId, cartId },
            CheckoutSupportedDeliveryModesQueryResetEvent
          );

          this.eventService.dispatch({}, CheckoutQueryResetEvent);
        })
    );
  }

  protected onDeliveryAddressSet(): void {
    this.subscriptions.add(
      this.eventService
        .get(CheckoutDeliveryAddressSetEvent)
        .subscribe(({ userId, cartId }) => {
          this.eventService.dispatch(
            { userId, cartId },
            CheckoutSupportedDeliveryModesQueryResetEvent
          );

          this.eventService.dispatch({}, CheckoutQueryResetEvent);
        })
    );
  }

  protected onDeliveryAddressCleared(): void {
    this.subscriptions.add(
      this.eventService
        .get(CheckoutDeliveryAddressClearedEvent)
        .subscribe(() =>
          this.eventService.dispatch({}, CheckoutQueryResetEvent)
        )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
